// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0b41ebd0","977":"925f0358"}[chunkId] + ".chunk.js";
};